export default __webpack_public_path__ + "static/media/fw-angela-er-Rose Gold.d36ad673.mp4";